<ng-container [formGroup]="formGroup">
    <div #reference (focusin)="isFocused = true" (focusout)="isFocused = false">
        <ngx-intl-tel-input
            searchCountryPlaceholder="{{'country.search.value' | translate}}"
            formControlName="{{controlName}}"
            [customPlaceholder]="nativePlaceholder"
            [inputId]="inputId"
            [maxLength]="maxLength"
            [cssClass]="cssClass"
            [preferredCountries]="preferredCountries"
            [searchCountryField]="searchCountryField"
            [selectedCountryISO]="selectedCountryISO"
            [separateDialCode]="separateDialCode"
            [numberFormat]="numberFormat"
            [phoneValidation]="phoneValidation"
            [enableAutoCountrySelect]="enableAutoCountrySelect"
            [enablePlaceholder]="enablePlaceholder"
            [searchCountryFlag]="searchCountryFlag"
            [selectFirstCountry]="selectFirstCountry"
        >
        </ngx-intl-tel-input>

        @if(customPlaceholder) {

            <label class="phone-label" [class.floating]="isLabelFloating" [attr.for]="inputId">{{ customPlaceholder }}</label>
        }
    </div>
</ng-container>
